import styled from 'styled-components';
import Screen from '@shared/utils/screen';
import Color from '@shared/assets/style/default/color';
import { TRANSITION } from '@shared/types/constants/animations';

interface Props {
  active: boolean;
}

const SwitcherBall = styled.div<Props>`
  width: ${65 * Screen.widthRatio}px;
  height: ${65 * Screen.widthRatio}px;
  background: ${(props) => (props.active ? Color.modal.title : 'grey')};
  border-radius: ${88 * Screen.widthRatio}px;
  position: relative;
  top: ${6 * Screen.widthRatio}px;
  left: ${7 * Screen.widthRatio}px;
  transition: ${TRANSITION.SWITCHER_BALL};
  -webkit-transition: ${TRANSITION.SWITCHER_BALL};
`;

export default SwitcherBall;
